import React from 'react';

export default function MaintenanceTicket({ tickets }) {
  return (
    <div style={styles.container}>
      <h3 style={styles.heading}>Maintenance</h3>
      {tickets.map(t => (
        <div key={t.id} style={styles.ticket}>
          <strong>{t.subject}</strong><br/>
          {t.status} • {t.createdAt}
        </div>
      ))}
    </div>
  );
}

const styles = {
  container: { padding: '1rem', background: '#fff', borderRadius: 8 },
  heading:   { margin: 0, marginBottom: '0.5rem' },
  ticket:    {
    padding: '0.5rem', borderBottom: '1px solid #eee',
    fontSize: '0.9rem'
  }
};